import { useState, useEffect } from "react";
import axiosInstance from "../axiosInstance";

const useRequestComprehensiveDetails = (requestProgressId, persona, refetch) => {
  const [requestDetails, setRequestDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  
  useEffect(() => {
    const fetchRequestDetails = async () => {
      if (!requestProgressId) return;
      
      setLoading(true);
      setError(null);
      
      try {
        const link = persona === "customer" 
          ? `/api/requests/enduser/details/${requestProgressId}`
          : `/api/requests/details/${requestProgressId}`;
          
        const response = await axiosInstance.get(link);
        setRequestDetails(response.data);
      } catch (error) {
        console.error("Failed to fetch comprehensive request details", error);
        setError(error);
      } finally {
        setLoading(false);
      }
    };
    
    fetchRequestDetails();
  }, [requestProgressId, persona, refetch]);
  
  return { requestDetails, loading, error };
};

export { useRequestComprehensiveDetails };
